<template>
    <div class="booking-management parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <!-- <Breadcrumb /> -->
        <h1>預定管理</h1>
        <tabs :key="componentKey">
            <tab name="待簽署合約" @click="$analytics.logEvent('預定管理_待簽署合約', { screen_name: '預定管理_待簽署合約'})" :selected="selected.beSigned">
                <booking-list></booking-list>
            </tab>
            <tab name="結束預定合約" @click="$analytics.logEvent('預定管理_結束預定合約', { screen_name: '預定管理_結束預定合約'})" :selected="selected.finished">
                <finished-list></finished-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import BookingTableList from '@/components/landlord/houseStatus/bookingManagement/BookingTableList.vue';
import BookingFinishedTableList from '@/components/landlord/houseStatus/bookingManagement/BookingFinishedTableList.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            selected: {
                beSigned: false,
                finished: false,
            },
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        this.$analytics.logEvent('預定管理', { screen_name: '預定管理'})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        isModalMode: function (val) {
            if(val){
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            }else{
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            }
            
        },
        $route:{
            handler: function (val) {
                this.selectTabByHash()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#待簽署合約' ){
                this.selected.beSigned = true
            }else if( hashTag == '#結束預定合約' ){
                this.selected.finished = true
            }else{
                this.selected.beSigned = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.beSigned = false
            this.selected.finished = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        'booking-list': BookingTableList,
        'finished-list': BookingFinishedTableList,
        Tabs,
        Tab,
        Breadcrumb,
        RentSelect
    }
}
</script>
<style lang="scss">
    .booking-management{
        position: relative;
        margin-top: 42px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        .tabs{
            position: absolute;
            top: 2px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
    }
    .booking-management.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        > h1{
            position: fixed;
            top: -4px;
            z-index: 8;
        }
        
        .tabs{
            position: fixed;
            margin-left: 152px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
            .table-list{
                border-radius: 0 0 10px 10px;
                > .btn-group{
                    position: fixed;
                    top: 18px;
                    right: unset;
                    z-index: 10;
                    margin-left: 788px;
                }
                .mask{
                    position: fixed;
                    background: #f6f6f6;
                    width: 1190px;
                    height: 50px;
                    top: 81px;
                    margin-left: -15px;
                    z-index: 9;
                }
                .table-list-title{
                    position: fixed;
                    width: 1154px;
                    background: #fff;
                    top: 96px;
                    border-radius: 10px 10px 0 0 ;
                    z-index: 9;
                }
            }
            
        }
    }
    @media screen and (max-width: 1280px) {
        .booking-management{
            .btn-group{
                right: 34px;
            }
        }
        .booking-management.fixed{
            .tool-bar-mask{
                margin-left: -24px;
            }
            
            .tabs-details{
                .table-list{
                    .table-list-title{
                        width: 1082px;
                    }
                    >.btn-group{
                        margin-left: 775px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/BookingManagementPages/BookingManagementDefault.vue